import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/view/login/login'
import Audit from '@/view/audit/audit'
import product from '@/view/product/product'
import balance from '@/view/balance/balance'
import Expert from '@/view/expert/index'
import Link from '@/view/link/index'
// import {state} from '../store/index'
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
}
Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      redirect:"/login"
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/home',
      redirect:"/audit",
      component: () => import('@/view/home'),
      children: [
        {
          path: '/homepage',
          name: 'homepage',
          meta: [{ title: '首页' }],
          component: () => import('@/view/homepage/homepage')
        },
        {
          path: '/audit',
          name: 'audit',
          component: Audit,
        },
        {
          path: '/product',
          name: 'product',
          component: product,
        },
        {
          path: '/balance',
          name: 'balance',
          component: balance,
        },
        {
          path: '/expert',
          name: 'Expert',
          component: Expert
        },
        {
          path: '/link',
          name: 'Link',
          component: Link
        }
      ]
    },
    {
      path: '/*',
      component: () => import('@/view/error-page/404')
    },
  ]
})
/**
 *
 */
// beforeEach 拦截守卫 对没有token令牌的进行拦截
router.beforeEach((to, from, next) => {
  if (to.path === '/login') return next()

  const token = window.sessionStorage.getItem('token')

  if (!token) return next('/login')

  next()
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js